
import {
  createStore
} from 'vuex'

const defaultFirstTabKey = 'game_sign_contract'
const defaultSecondTabKey = 'lysdk'

export default createStore({
  state: {
    routes: [],
    firstTabKey: sessionStorage.getItem('firstTabKey'),
    secondTabKey: sessionStorage.getItem('secondTabKey'),
    devId: sessionStorage.getItem('devId'),
    sjt: sessionStorage.getItem('sjt'),
    selectedContractId: Number, // 标识选中的协议id，在协议状态为驳回、待确认、申请续签时使用
    gameName: sessionStorage.getItem('gameName'),
    unionOperateType: sessionStorage.getItem('unionOperateType'),
    gameStatus: sessionStorage.getItem('gameStatus'),
    appTypeText: sessionStorage.getItem('appTypeText'),
    companyName: sessionStorage.getItem('companyName'),
    transferId: sessionStorage.getItem('transferId'),
    hasUnionPackageGame: sessionStorage.getItem('hasUnionPackageGame') === 'true'
  },
  mutations: {
    setRoutes (state, payload) {
      state.routes = payload.routes
    },
    initDevId (state, payload) {
      state.devId = payload.devId
      sessionStorage.setItem('devId', state.devId)
    },
    initTransferId (state, payload) {
      state.transferId = payload.transferId
      sessionStorage.setItem('transferId', state.transferId)
    },
    initCompanyName (state, payload) {
      state.companyName = payload.companyName
      sessionStorage.setItem('companyName', state.companyName)
    },
    initHasUnionPackageGame (state, payload) {
      state.hasUnionPackageGame = payload.hasUnionPackageGame === true || payload.hasUnionPackageGame === 'true'
      sessionStorage.setItem('hasUnionPackageGame', String(state.hasUnionPackageGame))
    },
    initSjt (state, payload) {
      state.sjt = payload.sjt
      sessionStorage.setItem('sjt', state.sjt)
    },
    modifyGameName (state, payload) {
      state.gameName = payload.gameName
      sessionStorage.setItem('gameName', state.gameName)
    },
    modifyGameStatus (state, payload) {
      state.gameStatus = payload.gameStatus
      sessionStorage.setItem('gameStatus', state.gameStatus)
    },
    modifyAppTypeText (state, payload) {
      state.appTypeText = payload.appTypeText
      sessionStorage.setItem('appTypeText', state.appTypeText)
    },
    modifyunionOperateType (state, payload) {
      state.unionOperateType = payload.unionOperateType
      sessionStorage.setItem('unionOperateType', state.unionOperateType)
    },
    modifyFirstTabKey (state, payload) {
      if (payload.firstTabKey === '') {
        state.firstTabKey = defaultFirstTabKey
      } else {
        state.firstTabKey = payload.firstTabKey
      }
      sessionStorage.setItem('firstTabKey', state.firstTabKey)
    },
    modifySecondTabKey (state, payload) {
      if (payload.secondTabKey === '') {
        state.secondTabKey = defaultSecondTabKey
      } else {
        state.secondTabKey = payload.secondTabKey
      }
      sessionStorage.setItem('secondTabKey', state.secondTabKey)
    },
    modifySelectedContractId (state, payload) {
      if (payload.selectedContractId === 0) {
        state.selectedContractId = 0
      } else {
        state.selectedContractId = payload.selectedContractId
      }
    }
  },
  actions: {},
  modules: {}
})
